"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localText = exports.PaginationAction = void 0;
/**
 * PaginationAction enum
 *
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/Pagination/Pagination.static.ts Source}
 */
var PaginationAction;
(function (PaginationAction) {
    PaginationAction[PaginationAction["GoToNextPage"] = 0] = "GoToNextPage";
    PaginationAction[PaginationAction["GoToPreviousPage"] = 1] = "GoToPreviousPage";
    PaginationAction[PaginationAction["GoToFirstPage"] = 2] = "GoToFirstPage";
    PaginationAction[PaginationAction["GoToLastPage"] = 3] = "GoToLastPage";
    PaginationAction[PaginationAction["GoToSpecificPage"] = 4] = "GoToSpecificPage";
})(PaginationAction = exports.PaginationAction || (exports.PaginationAction = {}));
exports.localText = {
    firstPage: 'First page',
    lastPage: 'Last page',
    nextPage: 'Next page',
    previousPage: 'Previous page',
    itemsOnPage: function (currentPage, numberOfPages) { return "Page ".concat(currentPage, " of ").concat(numberOfPages); },
};
